<template>
  <div>

    <vs-tabs alignment="fixed">
      <vs-tab label="Detalles documento">
        <div class="tab-text">
          <div>
            <vs-card v-if="!popupAddSignatures">
              <div class="p-1">
                <div slot="header">
                  <h4 class="pb-2 text-primary">Detalles:</h4>
                </div>
                <div>
                  <h6>Nombre del documento: </h6>
                  <p class="pb-2">{{ document.attributes.file_name }}</p>
                  <h6>Hash: </h6>
                  <p class="brakeall font-13 pb-2">{{ document.attributes.original_hash.toLowerCase() }}</p>
                  <h6>Estrategia de firmado: </h6>
                  <p class="brakeall font-13 pb-2">{{ sign_strategies[document.attributes.signature_mode] }}</p>
                  <div v-if="document.attributes.createdBy">
                    <h6>Creado por: </h6>
                    <p class="brakeall font-13 pb-2">{{ document.attributes.createdBy }}</p>
                  </div>
                  <div class="flex items-center">
                    <h6>Métodos configurados en el documento:</h6>
                    <vx-tooltip v-if="canEditSignatureMethods" text="Cambiar métodos de firma del documento" position="top" class="d-inline-block ml-2">
                      <feather-icon icon="Edit2Icon" svgClasses="w-4 h-4 hover:text-primary stroke-current cursor-pointer" @click="openDocumentMethodsPrompt" />
                    </vx-tooltip>
                  </div>
                  <div class="flex flex-wrap items-center pt-1 pb-2">
                    <span 
                      v-for="(methodObj, idx) in getDocumentGlobalMethodsObjects(document)" 
                      :key="idx"
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-[#f3f0ff] text-[#7c3aed] border border-[#7c3aed]/30 shadow-xs mr-2 mb-1.5"
                    >
                      <img :src="methodObj.icon" :alt="methodObj.label" style="width: 16px; height: 16px; margin-right: 6px; object-fit: contain;">
                      <span>{{ methodObj.label }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </vs-card>
            <vs-card class="mb-0">
              <div>
                <vs-list>
                <div class="vx-list-header text-primary font-bold mb-2">Firmantes</div>
                <div 
                  class="py-3 px-2 border-b border-gray-100 last:border-0 flex items-center justify-between"
                  v-for="listItem in document.relationships.signatories.data" 
                  :key="listItem.attributes.email"
                >
                  <div class="flex items-start flex-1 min-w-0 mr-2">
                    <div class="shrink-0 flex-shrink-0 mr-3 mt-1" style="flex-shrink: 0; min-width: 38px;">
                      <vs-avatar :text="listItem.attributes.name.split(' ').slice(0,2).join(' ').trim()" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h5 class="font-bold text-gray-800 text-sm mb-0">{{ listItem.attributes.name }}</h5>
                      <p class="text-xs text-gray-500 mb-1">{{ listItem.attributes.email }}</p>
                      
                      <!-- Badges de métodos permitidos por firmante -->
                      <div class="flex items-center flex-wrap my-1" v-if="getSignerAllowedMethodsObjects(listItem)">
                        <span class="text-xs font-semibold text-gray-600 mr-1.5 mb-1">Tipos de firma permitidos:</span>
                        <span 
                          v-for="(methodObj, mIdx) in getSignerAllowedMethodsObjects(listItem)" 
                          :key="mIdx"
                          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-[#f3f0ff] text-[#7c3aed] border border-[#7c3aed]/30 mr-1 mb-1"
                        >
                          <img :src="methodObj.icon" :alt="methodObj.label" style="width: 14px; height: 14px; margin-right: 4px; object-fit: contain;" v-if="methodObj.icon">
                          <span>{{ methodObj.label }}</span>
                        </span>
                      </div>

                      <div class="mt-1">
                        <span 
                          :style="getSummarySignerStatus(listItem).badgeStyle"
                        >
                          {{ getSummarySignerStatus(listItem).text }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="flex items-center">
                    <vx-tooltip v-if="canEditSignatureMethods && listItem.attributes.sign_status==='PENDING'" text="Cambiar métodos de firma" position="top" class="d-inline-block">
                      <feather-icon icon="SlidersIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="openSignerMethodsPrompt(listItem)" />
                    </vx-tooltip>

                    <vx-tooltip v-if="listItem.attributes.sign_status==='PENDING'" text="Cambiar email" position="top" class="d-inline-block">
                      <feather-icon icon="SendIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="emailUpdatePrompt=true;signatureToUpdate=listItem" />
                    </vx-tooltip>

                    <vx-tooltip v-if="listItem.attributes.sign_status==='PENDING'" text="Copiar enlace de firma" position="top" class="d-inline-block">
                      <feather-icon icon="ClipboardIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="copySignatureLink(listItem)" />
                    </vx-tooltip>

                    <vx-tooltip v-if="signaturesFlows.find(item => item.signature_id === listItem.id) && signaturesFlows.find(item => item.signature_id === listItem.id).attributes.signature_flow_id" text="Mostrar detalle del flujo de firmado" position="top" class="d-inline-block">
                      <feather-icon icon="EyeIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="signatureDetailPrompt=true;signatureToUpdate=listItem" />
                    </vx-tooltip>
                  </div>
                </div>
                </vs-list>
                <vs-button v-if="isAvailableToAddSignatures" class="mt-2" @click="popupAddSignatures = true">Añadir firmantes</vs-button>
              </div>
            </vs-card>

            <vs-card v-if="document.attributes.sign_status === 4" class="mb-0">
              <div slot="header">
                <h4 class="pb-2 text-primary">Motivo de rechazo:</h4>
              </div>
              <div v-html="document.attributes.rejected_message ? document.attributes.rejected_message : 'El firmante no dejo un motivo'">
              </div>
            </vs-card>

            <vs-card class="p-2 mt-5 mb-0 sign" v-if="popupAddSignatures">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <h4 class="pb-2 text-primary">Añadir firmantes</h4>
                  <p>Añade a las personas que deberán firmar los documentos</p>
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2">
                  <vs-input class="w-full" label-placeholder="Nombre" v-model="name" />
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2">
                  <vs-input class="w-full" label-placeholder="Correo" v-model="email" />
                </div>
                <div class="vx-col w-full mb-2">
                  <vs-input class="w-full" label-placeholder="Restringir con RFC o CURP (opcional)" v-model="rfc" />
                  <vs-button class="mt-3" type="border" @click="addSignature">Añadir firmante</vs-button>
                </div>

                <div class="vx-col w-full">
                  <vs-list v-if="signatures.length">
                    <vs-list-header title="Firmantes añadidos" color="secondary"></vs-list-header>
                    <p v-if="!signatures.length">No hay firmantes aún, prueba añadiendo uno con el formulario.</p>
                    <vs-list-item v-if="signatures.length" class="list-item" v-for="listItem in signatures" :key="listItem.email" :title="listItem.name" :subtitle="listItem.email">
                      <vs-avatar slot="avatar" :text="listItem.name.split(' ').slice(0,2).join(' ').trim()" />
                    </vs-list-item>
                  </vs-list>
                  <p>Cuando termines de añadir todos los firmantes finaliza aquí</p>
                  <vs-button class="mt-2" @click="updateDocument">Actualizar documento</vs-button>
                  <vs-button @click="popupAddSignatures = false" class="float-right mt-2" type="border">Cancelar</vs-button>
                </div>
              </div>
            </vs-card>
          </div>
          <vs-button type="border" @click="companiesPopUp = true">Mover</vs-button>
        </div>
      </vs-tab>

      <vs-tab label="Vista previa documento">
        <div class="tab-text mb-0">
          <vs-card class="mb-0">
            <div slot="header">
              <h4 class="pt-2 text-primary bold">Vista previa</h4>
            </div>
            <div class="mb-0">
              <ReactPdfViewer class="embed-h background-fb card-p" v-if="isShowPdf" :pdf="api_url + '/documents/' + document.id + '/download_original'" height="100%"></ReactPdfViewer>
            </div>
          </vs-card>
        </div>
      </vs-tab>

    </vs-tabs>

    <vs-prompt
    @cancel="emailToUpdate=''"
    @accept="changeEmail"
    title="Cambio de correo electrónico"
    accept-text="Aceptar"
    cancel-text="Cancelar"
    :active.sync="emailUpdatePrompt"
    >
      <vs-input class="center-element" placeholder="Ingresa un correo electrónico" v-model="emailToUpdate" />
    </vs-prompt>

    <vs-prompt
      @accept="saveDocumentMethods"
      title="Métodos de firma del documento"
      accept-text="Guardar"
      cancel-text="Cancelar"
      :is-valid="documentMethodsForm.length > 0"
      :active.sync="documentMethodsPrompt"
    >
      <p class="mb-3 text-sm">Elige cómo pueden firmar quienes aún no han firmado. Los firmantes con métodos propios conservan los suyos.</p>
      <signature-method-cards v-model="documentMethodsForm" />
      <p v-if="!documentMethodsForm.length" class="text-danger mt-3 text-xs text-center">Debes seleccionar al menos un método de firma.</p>
    </vs-prompt>

    <vs-prompt
      @accept="saveSignerMethods"
      title="Métodos de firma del firmante"
      accept-text="Guardar"
      cancel-text="Cancelar"
      :is-valid="!signerMethodsRestricted || signerMethodsForm.length > 0"
      :active.sync="signerMethodsPrompt"
    >
      <p class="mb-3 text-sm" v-if="signerToUpdateMethods"><strong>{{ signerToUpdateMethods.attributes.name }}</strong> ({{ signerToUpdateMethods.attributes.email }})</p>
      <div class="flex items-center mb-3">
        <vs-switch v-model="signerMethodsRestricted" />
        <span class="ml-2 text-sm">Restringir los métodos de este firmante</span>
      </div>
      <div v-if="signerMethodsRestricted">
        <p class="text-xs text-gray-700 mb-3 font-bold">Selecciona los métodos de firma permitidos para este firmante:</p>
        <signature-method-cards v-model="signerMethodsForm" />
        <p v-if="!signerMethodsForm.length" class="text-danger mt-3 text-xs text-center">Debes seleccionar al menos un método de firma.</p>
      </div>
      <p v-else class="text-sm">Usará los métodos configurados en el documento.</p>
    </vs-prompt>

    <vs-prompt
      @accept="moveDocument"
      @cancel="selectedCompanyToMove=null"
      title="Mover documento a una nueva carpeta de trabajo"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :is-valid="isDialogMoveDocumentValid"
      :active.sync="companiesPopUp"
    >
      <v-select placeholder="Selecciona una carpeta de trabajo" v-model="selectedCompanyToMove" :options="owned_companies" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
    </vs-prompt>

    <vs-prompt
      @cancel="signatureDetailPrompt = false"
      @accept="signatureDetailPrompt = false"
      title="Detalles del flujo de firmado"
      :buttons-hidden="true"
      :active.sync="signatureDetailPrompt"
    >
      <p><strong>Número de intentos realizados: </strong>{{ getSignatureFlow ? getSignatureFlow.attributes.signature_flow_try : '' }}</p>
      <br>
      <p class="flex items-center">
        <strong>Estatus del flujo de firmado: </strong>
        <span class="ml-1">{{ getSignatureFlow ? getSignatureFlowStatusText(getSignatureFlow.attributes.signature_flow_status) : '' }}</span>
        <vx-tooltip
          v-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'ON_HOLD'"
          text="El flujo se encuentra en espera de que el firmante complete el proceso de firmado."
          position="top"
          class="d-inline-block ml-2"
        >
          <feather-icon icon="InfoIcon" svgClasses="w-4 h-4 text-warning align-middle cursor-pointer" />
        </vx-tooltip>
        <vx-tooltip
          v-if="getSignatureFlow && (getSignatureFlow.attributes.signature_flow_status === 'PROCESSING' || getSignatureFlow.attributes.signature_flow_status === 'IN_PROGRESS')"
          text="El flujo de firmado se encuentra en proceso de verificación."
          position="top"
          class="d-inline-block ml-2"
        >
          <feather-icon icon="ClockIcon" svgClasses="w-4 h-4 text-primary align-middle cursor-pointer" />
        </vx-tooltip>
        <vx-tooltip
          v-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'PENDING'"
          text="El firmante ya completó su verificación. Verificamex espera a que la Lista Nominal del INE salga de mantenimiento para confirmar su identidad."
          position="top"
          class="d-inline-block ml-2"
        >
          <feather-icon icon="ClockIcon" svgClasses="w-4 h-4 text-primary align-middle cursor-pointer" />
        </vx-tooltip>
        <vx-tooltip
          v-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'COMPLETED'"
          :text="isSignatoryPending ? (getSignatureFlow.attributes.signature_flow_pending_signature ? 'Verificación completada. La firma se está colocando en el documento.' : 'Verificación completada. El firmante aún debe realizar su trazo de firma.') : 'El flujo de firmado ha sido completado con éxito.'"
          position="top"
          class="d-inline-block ml-2"
        >
          <feather-icon icon="CheckCircleIcon" svgClasses="w-4 h-4 text-success align-middle cursor-pointer" />
        </vx-tooltip>
        <vx-tooltip
          v-if="getSignatureFlow && (getSignatureFlow.attributes.signature_flow_status === 'ERROR' || getSignatureFlow.attributes.signature_flow_status === 'FAILED')"
          text="Ocurrió un error en la verificación del flujo de firmado."
          position="top"
          class="d-inline-block ml-2"
        >
          <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4 text-danger align-middle cursor-pointer" />
        </vx-tooltip>
      </p>

      <div v-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'ON_HOLD'" class="p-3 my-2 rounded flex items-center" style="background-color: rgba(255, 159, 67, 0.15); border-radius: 6px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
        <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 text-warning mr-2 flex-shrink-0" />
        <span class="text-sm">
          <strong>En espera:</strong> El proceso de firmado está en espera hasta que el firmante complete el proceso de firmado.
        </span>
      </div>

      <div v-else-if="getSignatureFlow && (getSignatureFlow.attributes.signature_flow_status === 'PROCESSING' || getSignatureFlow.attributes.signature_flow_status === 'IN_PROGRESS')" class="p-3 my-2 rounded flex items-center" style="background-color: rgba(115, 103, 240, 0.15); border-radius: 6px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
        <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 text-primary mr-2 flex-shrink-0" />
        <span class="text-sm">
          <strong>En proceso:</strong> El proceso de firmado o verificación se está procesando actualmente. Por favor, espere unos momentos.
        </span>
      </div>
      <div v-else-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'PENDING'" class="p-3 my-2 rounded flex items-center" style="background-color: rgba(115, 103, 240, 0.15); border-radius: 6px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
        <feather-icon icon="ClockIcon" svgClasses="w-5 h-5 text-primary mr-2 flex-shrink-0" />
        <span class="text-sm">
          <strong>En espera del INE:</strong> El firmante ya completó su verificación<span v-if="getSignatureFlow.attributes.signature_flow_pending_signature"> y su trazo de firma</span>, pero la Lista Nominal del INE está en mantenimiento.
          <span v-if="getSignatureFlow.attributes.signature_flow_pending_signature">La firma se colocará automáticamente cuando el INE confirme su identidad (máximo 72 h).</span>
          <span v-else>En cuanto el INE confirme su identidad podrá terminar de firmar (máximo 72 h).</span>
        </span>
      </div>
      <div v-else-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'COMPLETED' && getSignatureFlow.attributes.signature_flow_pending_signature && isSignatoryPending" class="p-3 my-2 rounded flex items-center" style="background-color: rgba(40, 199, 111, 0.15); border-radius: 6px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
        <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 text-success mr-2 flex-shrink-0" />
        <span class="text-sm">
          <strong>Colocando la firma:</strong> Verificamex confirmó la identidad del firmante y su firma se está colocando en el documento.
        </span>
      </div>
      <div v-else-if="getSignatureFlow && getSignatureFlow.attributes.signature_flow_status === 'COMPLETED' && isSignatoryPending" class="p-3 my-2 rounded flex items-center" style="background-color: rgba(40, 199, 111, 0.15); border-radius: 6px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
        <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 text-success mr-2 flex-shrink-0" />
        <span class="text-sm">
          <strong>Verificación completada:</strong> El firmante ya completó con éxito el proceso de verificación. <strong>Únicamente le falta realizar el trazo de su firma para finalizar.</strong>
        </span>
      </div>
      <br v-else>

      <p v-if="hasErrorMessage(getSignatureFlow)"><strong>Mensaje de error de la última verificación: </strong>{{ getSignatureFlow.attributes.signature_flow_error_message }}</p>
      <vs-card class="mt-2" v-if="getSignatureFlow ? getSignatureFlow.attributes.signature_flow_try >= 3 : false">
        <small>Cuando los intentos permitidos exceden, es posible reiniciar el contador <strong>por el costo de una firma adicional</strong> (cada vez que se reinicia se consume una firma)</small><br>
        <vs-button style="margin: 0 auto; display: block!important;" type="border" @click="resetSignatureFlowTries">Reiniciar intentos</vs-button>
      </vs-card>
    </vs-prompt>

  </div>
</template>

<script>
import router from "@/router";
import {ReactInVue} from 'vuera';
import ReactPdfViewer from "../../../../components/viewer-pdf/ReactPdfViewer";
import {API_URL, SIGN_STRATEGIES, SIGN_STATUS} from "../../../../config/app";
import {mapState} from "vuex";
import vSelect from 'vue-select'
import SignatureMethodCards from "./SignatureMethodCards";

export default {
  name: "DetailDocument",
  props: ['uuid', 'closePopup'],
  components: {
    'ReactPdfViewer': ReactInVue(ReactPdfViewer),
    'v-select': vSelect,
    SignatureMethodCards
  },
  data() {
    return {
      companiesPopUp: false,
      popupAddSignatures: false,
      document: null,
      api_url: API_URL,
      isShowPdf: true,
      signatures: [],
      signaturesFlows: [],
      name: '',
      email: '',
      rfc: '',
      sign_strategies: SIGN_STRATEGIES,
      sign_status: SIGN_STATUS,
      emailToUpdate: '',
      emailUpdatePrompt: false,
      signatureToUpdate: null,
      selectedCompanyToMove: null,
      signatureDetailPrompt: false,
      // Métodos elegidos en las tarjetas: IDENTITY, SIMPLE, EFIRMA, FIREL. Para el documento,
      // IDENTITY y SIMPLE se guardan como VERIFICAMEX con proveedor VERIFICAMEX o LOCAL, y FIREL
      // incluye TEPJF (igual que al crear; ver saveDocumentMethods).
      documentMethodsPrompt: false,
      documentMethodsForm: [],
      signerMethodsPrompt: false,
      signerMethodsRestricted: false,
      signerMethodsForm: [],
      signerToUpdateMethods: null
    }
  },
  watch: {
    uuid(val) {
      if (val) {
        this.isShowPdf = false;
        this.$store.dispatch("document/getDocument", {uuid: val})
          .then(document => {
            this.document = document;
            this.isShowPdf = true;
            this.popupAddSignatures = false;
            this.signatures = [];
            this.name = '';
            this.email = '';
            this.rfc = '';
          })
      } else {
        router.push("/");
      }
    }
  },
  computed: {
    ...mapState({
      owned_companies: function (state) {
        return state.account.user.me.owned_companies;
      },
    }),
    isDialogMoveDocumentValid() {
      return this.selectedCompanyToMove;
    },
    isAvailableToAddSignatures() {
      return (this.document.attributes.sign_status === 1) && this.document.attributes.signature_ordered === "INACTIVE";
    },
    // Solo mientras el documento no esté firmado (3) ni rechazado (4); la API aplica la misma regla.
    canEditSignatureMethods() {
      return !!this.document && [1, 2].includes(this.document.attributes.sign_status);
    },
    getSignatureFlow() {
      if (this.signatureToUpdate) {
        let found = this.signaturesFlows.find(item => item.signature_id === this.signatureToUpdate.id)
        console.log(found)
        if (found) {
          return found
        }
      }
    },
    isSignatoryPending() {
      return this.signatureToUpdate && this.signatureToUpdate.attributes && (
        this.signatureToUpdate.attributes.sign_status === 'PENDING' ||
        this.signatureToUpdate.attributes.sign_status === 1
      );
    }
  },
  async created() {
    let instance = this;
    if (this.uuid) {
      this.$store.dispatch("document/getDocument", {uuid: this.uuid})
        .then(document => {
          this.document = document;
          document.relationships.signatories.data.forEach(async item => {
            let result = await this.$store.dispatch("document/getDocumentFromSignature", {uuid: item.id})
            if (result) {
              result.signature_id = item.id;
              instance.signaturesFlows.push(result)
              console.log(instance.signaturesFlows)
            }
          })
        })
    } else {
      router.push("/");
    }
  },
  methods: {
    getSignatureFlowStatusText(status) {
      if (!status) return '';
      const statusMap = {
        'ON_HOLD': 'En espera',
        'PROCESSING': 'En proceso',
        'IN_PROGRESS': 'En progreso',
        'COMPLETED': 'Completado',
        'PENDING': 'En espera del INE',
        'ERROR': 'Error',
        'REJECTED': 'Rechazado',
        'EXPIRED': 'Expirado',
        'FAILED': 'Fallido',
        'CANCELLED': 'Cancelado',
        'CANCELED': 'Cancelado',
        'SUCCESS': 'Completado'
      };
      return statusMap[status] || status;
    },
    hasErrorMessage(flow) {
      if (!flow || !flow.attributes) return false;
      const msg = flow.attributes.signature_flow_error_message;
      if (!msg) return false;
      const str = String(msg).trim().toLowerCase();
      return str !== '' && str !== 'null' && str !== 'undefined';
    },
    getSummarySignerStatus(listItem) {
      if (!listItem || !listItem.attributes) {
        return {
          text: 'Pendiente',
          badgeStyle: 'background-color: #f0f0f0; color: #595959; border: 1px solid #d9d9d9; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
        };
      }
      
      const statusRaw = listItem.attributes.sign_status;
      const isPending = statusRaw === 'PENDING' || statusRaw === 1;
      
      if (isPending && Array.isArray(this.signaturesFlows)) {
        const flow = this.signaturesFlows.find(item => item.signature_id === listItem.id);
        if (flow && flow.attributes && flow.attributes.signature_flow_status) {
          const flowStatus = flow.attributes.signature_flow_status;
          if (flowStatus === 'COMPLETED' && flow.attributes.signature_flow_pending_signature) {
            return {
              text: 'Colocando firma',
              badgeStyle: 'background-color: #e6f4ea; color: #137333; border: 1px solid #a8dab5; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          } else if (flowStatus === 'PENDING') {
            return {
              text: flow.attributes.signature_flow_pending_signature ? 'En espera del INE (ya firmó)' : 'En espera del INE',
              badgeStyle: 'background-color: #f3f0ff; color: #7c3aed; border: 1px solid #ddd6fe; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          } else if (flowStatus === 'COMPLETED') {
            return {
              text: 'Verificación completada (falta firma)',
              badgeStyle: 'background-color: #e6f4ea; color: #137333; border: 1px solid #a8dab5; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          } else if (flowStatus === 'PROCESSING' || flowStatus === 'IN_PROGRESS') {
            return {
              text: 'En verificación',
              badgeStyle: 'background-color: #f3f0ff; color: #7c3aed; border: 1px solid #ddd6fe; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          } else if (flowStatus === 'ON_HOLD') {
            return {
              text: 'En espera de verificación',
              badgeStyle: 'background-color: #fffbe6; color: #d48806; border: 1px solid #ffe58f; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          } else if (flowStatus === 'ERROR' || flowStatus === 'FAILED') {
            return {
              text: 'Error en verificación',
              badgeStyle: 'background-color: #fff1f0; color: #cf1322; border: 1px solid #ffa39e; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
            };
          }
        }
      }
      
      const defaultText = (SIGN_STATUS && SIGN_STATUS[statusRaw]) ? SIGN_STATUS[statusRaw] : (this.sign_status ? this.sign_status[statusRaw] : 'Pendiente');
      const isSigned = statusRaw === 'SIGNED' || statusRaw === 2 || statusRaw === 'COMPLETED';
      return {
        text: defaultText || 'Pendiente',
        badgeStyle: isSigned
          ? 'background-color: #e6f4ea; color: #137333; border: 1px solid #a8dab5; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
          : 'background-color: #f0f0f0; color: #595959; border: 1px solid #d9d9d9; border-radius: 12px; padding: 2px 10px; font-size: 0.72rem; font-weight: 600; display: inline-block;'
      };
    },
    getDocumentGlobalMethodsObjects(document) {
      if (!document || !document.attributes || !document.attributes.config) return [];
      const config = document.attributes.config;
      const methods = [];
      const allowTypes = (config.allow_type_signatures && config.allow_type_signatures.length)
        ? config.allow_type_signatures
        : ['VERIFICAMEX', 'EFIRMA', 'FIREL', 'TEPJF'];
      const identityProviders = (config.identity_providers && config.identity_providers.length)
        ? config.identity_providers
        : ['VERIFICAMEX'];

      if (allowTypes.includes('VERIFICAMEX') && identityProviders.includes('VERIFICAMEX')) {
        methods.push({ value: 'IDENTITY', label: 'Identidad (INE)', icon: require('@/assets/images/document/id.svg') });
      }
      if (allowTypes.includes('VERIFICAMEX') && identityProviders.includes('LOCAL')) {
        methods.push({ value: 'SIMPLE', label: 'Firma simple', icon: require('@/assets/images/document/sign.svg') });
      }
      if (allowTypes.includes('EFIRMA')) {
        methods.push({ value: 'EFIRMA', label: 'e.firma (SAT)', icon: require('@/assets/images/document/sat.svg') });
      }
      if (allowTypes.includes('FIREL') || allowTypes.includes('TEPJF')) {
        methods.push({ value: 'FIREL', label: 'FIREL (PJF)', icon: require('@/assets/images/document/firel.svg') });
      }
      
      return methods;
    },
    parseSignerAllowedMethods(listItem) {
      if (!listItem || !listItem.attributes) return [];
      let methods = listItem.attributes.allowed_signature_methods;
      if (typeof methods === 'string') {
        try {
          methods = JSON.parse(methods);
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(methods) ? methods : [];
    },
    getDocumentMethodKeys(document) {
      return this.getDocumentGlobalMethodsObjects(document).map(methodObj => methodObj.value);
    },
    reloadDocument() {
      return this.$store.dispatch("document/getDocument", {uuid: this.uuid})
        .then(document => {
          this.document = document;
        });
    },
    openDocumentMethodsPrompt() {
      this.documentMethodsForm = this.getDocumentMethodKeys(this.document);
      this.documentMethodsPrompt = true;
    },
    saveDocumentMethods() {
      const methods = this.documentMethodsForm;
      const allowTypeSignatures = [];
      const identityProviders = [];
      if (methods.includes('IDENTITY')) identityProviders.push('VERIFICAMEX');
      if (methods.includes('SIMPLE')) identityProviders.push('LOCAL');
      if (identityProviders.length) allowTypeSignatures.push('VERIFICAMEX');
      if (methods.includes('EFIRMA')) allowTypeSignatures.push('EFIRMA');
      if (methods.includes('FIREL')) allowTypeSignatures.push('FIREL', 'TEPJF');

      this.$store.dispatch("alert/clear");
      this.$store.dispatch("document/updateDocumentSignatureMethods", {
        documentUuid: this.document.id,
        allowTypeSignatures,
        // Sin VERIFICAMEX no se mandan: el backend conserva los actuales.
        identityProviders: identityProviders.length ? identityProviders : null
      }).then(
        () => {
          this.reloadDocument();
          this.$store.dispatch("alert/success", "Los métodos de firma del documento se actualizaron con éxito");
        },
        error => {
          this.$store.dispatch("alert/error", error);
        }
      );
    },
    openSignerMethodsPrompt(listItem) {
      const current = this.parseSignerAllowedMethods(listItem);
      this.signerToUpdateMethods = listItem;
      this.signerMethodsRestricted = current.length > 0;
      this.signerMethodsForm = [...current];
      this.signerMethodsPrompt = true;
    },
    saveSignerMethods() {
      // Sin restricción se manda vacío y el firmante usa los métodos del documento.
      const allowedSignatureMethods = this.signerMethodsRestricted ? this.signerMethodsForm : [];

      this.$store.dispatch("alert/clear");
      this.$store.dispatch("document/updateSignerSignatureMethods", {
        documentUuid: this.document.id,
        signatureUuid: this.signerToUpdateMethods.id,
        allowedSignatureMethods
      }).then(
        () => {
          this.reloadDocument();
          this.$store.dispatch("alert/success", "Los métodos de firma del firmante se actualizaron con éxito");
        },
        error => {
          this.$store.dispatch("alert/error", error);
        }
      );
    },
    getSignerAllowedMethodsObjects(listItem) {
      if (!listItem || !listItem.attributes) return null;

      const methods = this.parseSignerAllowedMethods(listItem);
      if (methods.length === 0) {
        return null;
      }

      const methodMap = {
        'IDENTITY': { label: 'Con identidad (INE)', icon: require('@/assets/images/document/id.svg') },
        'SIMPLE': { label: 'Firma simple', icon: require('@/assets/images/document/sign.svg') },
        'EFIRMA': { label: 'e.firma (SAT)', icon: require('@/assets/images/document/sat.svg') },
        'FIREL': { label: 'FIREL (PJF)', icon: require('@/assets/images/document/firel.svg') }
      };
      
      return methods.map(m => methodMap[m] || { label: m, icon: null });
    },
    moveDocument() {
      this.$store.dispatch("document/updateDocument", { document: { uuid: this.document.id }, company_id: this.selectedCompanyToMove.id }).then(
        () => {
          setTimeout(() => {
            location.reload(true);
          }, 500)
        }
      )
    },
    copySignatureLink(signature) {
      let signatureUrl = window.location.origin + "/signature/sign-document/" + signature.id;
      this.$copyText(signatureUrl).then(
        () => {
          this.onCopy();
        },
        () => {
          this.onError();
        }
      )
    },
    changeEmail() {
      this.$store.dispatch("alert/clear");
      this.$store.dispatch("document/updateSignatureEmail", {email: this.emailToUpdate, documentUuid: this.document.id, signatureUuid: this.signatureToUpdate.id})
      .then(
        () => {
          this.$store.dispatch("document/getDocument", {uuid: this.uuid})
            .then(document => {
              this.document = document;
            })
          this.emailToUpdate = "";
          this.$store.dispatch("alert/success", "El correo electrónico del firmante se ha actualizado con éxito");
        },
        error => {
          this.$store.dispatch("alert/error", error)
        }
      )
    },
    addSignature() {
      this.$store.dispatch("alert/clear", {});
      if (!this.name || !this.email) {
        this.$store.dispatch("alert/error", "Ingrese el nombre y correo electrónico del firmante para continuar");
        return;
      }
      this.signatures.push({
        name: this.name,
        email: this.email,
        rfc: this.rfc
      });
      this.name = "";
      this.email = "";
      this.rfc = "";
      this.$store.dispatch("alert/success", "Firmante añadido correctamente");
    },
    updateDocument() {
      if (!this.signatures.length) {
        this.$store.dispatch("alert/error", "Ingrese por lo menos un firmante para continuar");
        return;
      }
      this.$store.dispatch("document/updateDocument", {
        document: {
          uuid: this.uuid,
          signatures: this.signatures,
          tries: this.document.attributes.tries,
          remember_at: this.document.attributes.remember_at,
          remember_every: this.document.attributes.remember_every
        }
      })
      .then(() => {
        this.uuid = null;
        this.closePopup();
      })
    },
    resetSignatureFlowTries() {
      this.$store.dispatch("document/resetSignatureFlow", { signatureId: this.signatureToUpdate.id, signatureFlowId: this.getSignatureFlow.attributes.signature_flow_id }).then(
        result => {
          console.log(result)
          if (result.errors) {
            this.$vs.notify({
              title: 'Error',
              text: result.errors[0].detail,
              color: 'danger',
              position: 'top-center',
            })
          }
          this.emailUpdatePrompt = false
          this.closePopup();
        }
      );
    },
    onCopy() {
      this.$vs.notify({
        title: 'Éxito',
        text: 'El texto se ha copiado en el portapapeles',
        color: 'success',
        position: 'top-center',
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Falló',
        text: 'Falló la copia de texto',
        color: 'danger',
        position: 'top-center',
      })
    },
  }
}
</script>

<style scoped>
.vs-card--content{
  margin-bottom: 0px!important;
}



</style>
